import { addDate, formatDate, parseDate } from 'common/utils/dates';

import fetchScheduleRateConfiguration from '../../afterSalesSettings/actions/fetchScheduleRateConfiguration';
import { DATE_FORMATS } from '../../afterSalesSettings/constants';
import * as afterSalesSettingsSelectors from '../../afterSalesSettings/selectors';
import { getFieldsObjectFromArray } from '../helpers';
import * as selectors from '../selectors';

import initializeForm from './initializeForm';
import setModalFormOpenStatus from './setModalFormOpenStatus';

export default () => (dispatch, getState) => {
    const state = getState();

    const afterSalesSettings =
        afterSalesSettingsSelectors.getFetchDataData(state);

    const initialDate = selectors.getConsumptionHistoryLastDate(state);
    let finalDate = '';

    const isBimonthly = afterSalesSettings?.is_bimonthly;

    if (initialDate) {
        const parsedInitialDate = parseDate(initialDate, DATE_FORMATS.SUNWISE);
        const parsedFinalDate = addDate(parsedInitialDate, {
            months: isBimonthly ? 2 : 1,
        });
        finalDate = formatDate(parsedFinalDate, DATE_FORMATS.SUNWISE);
    }

    const newValues = {
        contracted_demand:
            afterSalesSettings?.contracted_demand?.[0]?.value || 0,
        exported_energy_price: afterSalesSettings?.exported_energy_price || 0,
        final_date: finalDate,
        initial_date: initialDate,
        is_bimonthly: isBimonthly ? '1' : '0',
        netted_exported_generation_price:
            afterSalesSettings?.netted_exported_generation_price || 0,
        periodicity_type: afterSalesSettings?.periodicity_type,
        ppa_active: afterSalesSettings?.ppa_active || false,
        rate: afterSalesSettings?.rate?.id,
        rate_division_summer: afterSalesSettings?.rate_division_summer?.id,
        subsidy_rate: afterSalesSettings?.subsidy_rate?.name,
    };

    const promises = [];

    if (newValues?.rate)
        promises.push(
            dispatch(
                fetchScheduleRateConfiguration({
                    certified: afterSalesSettings?.rate?.certified,
                    rate: newValues?.rate,
                    rate_division: afterSalesSettings?.rate_division?.id,
                }),
            ),
        );

    Promise.all(promises).then((scheduleRateConfiguration) => {
        newValues.hourly_contracted_demand = getFieldsObjectFromArray(
            afterSalesSettings?.contracted_demand,
            scheduleRateConfiguration?.[0]?.tiers_demand_distribution?.[0]
                ?.tiers,
        );

        dispatch(initializeForm(newValues));
        dispatch(setModalFormOpenStatus(true));
    });
};
